<template>
    <div class="ckeditor4" :class="{'myDisabled':disabled}">
        <textarea :id="id" :disabled="disabled"></textarea>
<!--        <span @click="clearValue()" class="el-icon-circle-close closeBtn" v-if="value!=''"></span>-->
    </div>
</template>
<script>
    /*eslint-disable*/
    import baseUrl,{imageUrl} from "@/constants";
    import guid from "@/common/guid";
    import symbolData from "@/api/symbol.json";
    import {dictApi} from "@/api/organization";

    export default {
        name: 'ckeditor4',
        props: {
            'stopPast':{
              type: Boolean,
              default: true
            },
            'value': {
                type: String,
                default: "",
            },
            'basicstyles':{
                type: Array,
                default: () => [ 'Subscript', 'Superscript' , 'Italic']
            },
            'insert': {
                type: Array,
                default: () => [ 'SpecialChar', 'unitdata']
            },
            'specialChars': {
                type: Array,
                default: () => ["%", "‰", "′", "″", "±", "°", "Ⅰ", "Ⅱ", "Ⅲ", "Ⅳ", "10", "℃", "Z", "α", "β", "γ", "Δ", "▽", "δ", "θ", "λ", "μ", "τ", "Φ", "Ω", "|t|", "ω", "＞", "≥", "＜", "≤", "～", "∞" ,"1","2","3","4","5","6","7","8","11","12",'a','b','c','d','e','×','f','m℃', 'mK']
            },
            'disabled': {
                type: Boolean,
                default: () => false
            }
        },
        mounted: function () {
            this.basicstyles.push('clear');
            const _this = this // 渲染编辑器
            _this.ckeditor = window.CKEDITOR.inline(_this.id, {
                toolbar :[
                    { name: 'basicstyles', items: this.basicstyles },
                    { name: 'insert', items: this.insert },
                ],
                extraPlugins:"clear, unitdata",
                specialChars: this.specialChars,
                symbol: _this.getsymbol().data,
                magicline_color : 'transparent',
                filebrowserUploadUrl: baseUrl + '/org-service/upload/ck?a=0',
                fileTools_requestHeaders: this.headers,
                removeDialogTabs: 'image:advanced;',
                //移除title
                title: false,
                //允许imgBase64
                allowedContent:true,
                enterMode: CKEDITOR.ENTER_BR,
                shiftEnterMode: CKEDITOR.ENTER_BR,
                removePlugins: 'contextmenu,liststyle,tabletools,tableselection',
                readOnly: this.disabled
            })    // 设置初始内容
            _this.ckeditor.setData(_this.value)     // 监听内容变更事件
            _this.ckeditor.on('change', function () {
                _this.$emit('input', _this.ckeditor.getData())
            })
            _this.ckeditor.on('blur', function () {
                _this.$emit('input', _this.ckeditor.getData())
            })

            _this.ckeditor.on( 'fileUploadResponse', function( evt ) {
                evt.stop();
                var data = evt.data,
                    xhr = data.fileLoader.xhr,
                    response = xhr.responseText.split( '|' );
                if ( response[ 1 ] ) {
                    data.message = JSON.parse(response[1]);
                    evt.cancel();
                } else {
                    data.url = imageUrl+JSON.parse(response[0]).url;
                    setTimeout(()=>{
                        _this.$emit('input', _this.ckeditor.getData())
                    },1000)
                }
            });
            _this.ckeditor.on( 'paste', function( evt ) {
              if(_this.stopPast){
                evt.stop();
              }
            });
        },
        data: function () {
            return {
                id: guid(),
                ckeditor: null,
                headers:{ Authorization: this.$store.state.Authorization },
            }
        },
        methods:{
            clearValue(){
                this.ckeditor.setData("");
            },
            getsymbol(){
              // dictApi.listDictSymbol({})
              return symbolData;
            }
        },
        watch: {     // 监听prop的变化，更新ckeditor中的值
            value: function () {
                if (this.value !== this.ckeditor.getData()) {
                    this.ckeditor.setData(this.value)
                }
            }
        },
        // 销毁组件前，销毁编辑器
        beforeDestroy: function () {
            if(CKEDITOR.instances[this.id]){
                CKEDITOR.instances[this.id].destroy()
            }
        }
    }
</script>
<style>
    .ckeditor4{
        position: relative;
    }
    .ckeditor4 p{
        margin: 0 !important;
        padding: 0 10px !important;
    }
    .cke_editable{
        padding:0px 10px;
        line-height: 40px;
    }
    .cke_dark_background a{
        width: 30px!important;
    }
    .cke_dark_backgroundBig a {
      width: 65px !important;
    }
    .ckeditor4 .closeBtn{
        float: right;
        position: absolute;
        top: 14px;
        right: 10px;
        cursor: pointer;
        color: rgb(217,219,224);
    }
    :deep(.cke_contents) {
      width: 500px;
    }
</style>
